export default function (to, from) {
  const route = to?.name ? to : useRoute()
  const { user } = useUser()
  const supervisorEmployer = useSupervisorEmployer()
  const dayjs = useDayjs()

  const ats = computed(() => {
    const currentUser = user.value
    const employment = currentUser?.employment ?? null
    const isSupervisor = !!currentUser?.isSupervisor
    const employer = isSupervisor && supervisorEmployer.value ? supervisorEmployer.value : (employment?.employer ?? null)
    const isAts =
      (route.name === 'ats' ||
        route.fullPath?.startsWith('/ats/') ||
        route.fullPath?.startsWith('/mon-compte') ||
        route.fullPath?.startsWith('/mon-profil')) &&
      !!employment

    const isSubscriptionCurrent = () => {
      if (!employer) return false
      const today = dayjs().format('YYYY-MM-DD')
      return (!employer.subscriptionStart || employer.subscriptionStart <= today) && employer.subscriptionEnd >= today
    }

    return {
      employer,
      employment,
      isAts,
      isMe(userId) {
        return currentUser.id === userId
      },
      isMyEmployment(employmentId) {
        return employment?.id === employmentId
      },
      isUserRole(roles) {
        if (!employment) return false
        roles = !Array.isArray(roles) ? roles.replace(/ /, '').split(',') : roles
        return !roles.length || roles.includes(employment.role)
      },
      hasEnoughCredits() {
        return employer?.subscriptionCredits > 0 || employer?.subscriptionType === 'ILLIMITE'
      },
      hasOption(option) {
        if (!employer?.subscriptionOptions) return false
        return employer.subscriptionOptions[option]
      },
      isSubscribed(types = [], checkDate = false) {
        if (!employer?.subscriptionType) return false
        if (checkDate && !isSubscriptionCurrent()) return false
        types = !Array.isArray(types) ? types.replace(/ /, '').split(',') : types
        return !types.length || types.includes(employer.subscriptionType)
      },
      isSubscriptionCurrent
    }
  })

  return ats
}
